var React = require('react');

function ChatHd (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M4.3,18.9h34.3c2.4,0,4.3,1.9,4.3,4.3v38.6l-8.6-8.6h-30c-2.4,0-4.3-1.9-4.3-4.3V23.2C0,20.8,1.9,18.9,4.3,18.9z","fill":"currentColor","key":0}),React.createElement("path",{"d":"M59.7,2.2H25.4c-2.4,0-4.3,1.9-4.3,4.2V17h4.3V6.5h34.3v25.3H45.4V36h14.3c2.4,0,4.3-1.9,4.3-4.2V6.5\n  C64,4.1,62.1,2.2,59.7,2.2z","fill":"currentColor","key":1})]);
}

ChatHd.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 64 64","style":{"enableBackground":"new 0 0 64 64"},"xmlSpace":"preserve"};

module.exports = ChatHd;

ChatHd.default = ChatHd;
